import { render, staticRenderFns } from "./dadosUsuario.vue?vue&type=template&id=cdebe790&scoped=true&"
import script from "./dadosUsuario.vue?vue&type=script&lang=js&"
export * from "./dadosUsuario.vue?vue&type=script&lang=js&"
import style0 from "./dadosUsuario.vue?vue&type=style&index=0&id=cdebe790&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdebe790",
  null
  
)

export default component.exports